import {Component, Input, OnInit} from '@angular/core';
import {FadeOutAnimation} from '@helpers/animations/fadeInOut.animation';

@Component({
    selector: 'app-documents-generation-button',
    templateUrl: './documents-generation-button.component.html',
    styleUrls: ['./documents-generation-button.component.scss'],
    animations: [
        FadeOutAnimation,
    ]
})
export class DocumentsGenerationButtonComponent implements OnInit {

    @Input() equipmentIds: number[] = [];

    constructor() {
    }

    ngOnInit() {
    }

}
